module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feedItem d-flex panel bg-lightest black"
  }, [_c('div', {
    staticClass: "leftSide d-flex flex-column align-items-center border-right-dark justify-content-center"
  }, [_c('img', {
    staticStyle: {
      "max-height": "130px",
      "max-width": "130px"
    },
    attrs: {
      "src": _vm.selectedOta.logo,
      "alt": ""
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "mt-4 color-1 bold underlined",
    attrs: {
      "href": _vm.selectedOta.website,
      "target": "_blank"
    }
  }, [_vm._v("Go to Website")])]), _vm._v(" "), _c('div', {
    staticClass: "rightSide d-flex flex-column p-4"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-grow-1"
  }, [_c('div', {
    staticClass: "fs-larger bold"
  }, [_vm._v(_vm._s(_vm.selectedOta.name) + " is here!")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v(_vm._s(_vm.selectedOta.description))])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('button', {
    staticClass: "btn blue w-100",
    on: {
      "click": _vm.learnMoreClick
    }
  }, [_vm._v("Learn More")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0eac083b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eac083b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/FeedcardNewOTA.vue
// module id = 2452
// module chunks = 0